import { useDispatch } from 'react-redux';
import useSavedFiltersQuery from '../api/queries/useSavedFiltersQuery';
import {
  setChosenShutdownFilter,
  setShutdownFilterValues,
} from '../../features/filterNew/model/actions';
import { useCallback } from 'react';
import moment from 'moment';

const useChooseFilter = () => {
  const dispatch = useDispatch();

  const { data: filters = [] } = useSavedFiltersQuery();

  const chooseFilter = useCallback(
    async (id) => {
      const chosenFilter = filters?.find((existingFilter) => {
        return existingFilter.id === id;
      });

      if (!!chosenFilter) {
        dispatch(
          setChosenShutdownFilter({
            id: chosenFilter?.id,
            name: chosenFilter?.name.trim(),
          })
        );

        const filterValues = JSON.parse(chosenFilter.filter);

        const { dateRange } = filterValues;

        const filter = {
          ...filterValues,
          dateRange: [moment(dateRange[0]), moment(dateRange[1])],
        };

        dispatch(setShutdownFilterValues(filter));
      }
    },
    [dispatch, filters]
  );

  return chooseFilter;
};

export default useChooseFilter;
